const DEBUG_VARIATION_LS = 'fast-debug-variation';
const VARIATION_LS = 'fast-variation';
export default function getUserVariation() {
    var _a;
    return localStorage.getItem(DEBUG_VARIATION_LS) || localStorage.getItem(VARIATION_LS) || ((_a = window === null || window === void 0 ? void 0 : window.FS_VARIATION) === null || _a === void 0 ? void 0 : _a.variation_id) || undefined;
}
export function setUserVariation(key) {
    if (key) {
        localStorage.setItem(VARIATION_LS, key);
        window.FS_VARIATION = { variation_id: key };
    }
    else {
        localStorage.removeItem(VARIATION_LS);
    }
}
//# sourceMappingURL=ABTesting.js.map